import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { Organizi8AppStateReducer } from './organizi8.reducer';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { Organizi8AppDBEffects } from './organizi8.effects';

@NgModule({
  imports: [
    StoreModule.forRoot(Organizi8AppStateReducer),
    EffectsModule.forRoot(Organizi8AppDBEffects),
    StoreDevtoolsModule.instrument({ maxAge: 10 }),
  ],
})
export class Organizi8ReduxStoreModule {}
